// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"779":"056bf7cd","883":"component---src-pages-404-js"}[chunkId] || chunkId) + "-" + {"629":"f1a4d43ec1309e8d5ed2","634":"510d96fbb4ec813ba45c","779":"0070296ca8d2e38f4b63","883":"83dde12bf0963f817b8f"}[chunkId] + ".js";
};